import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/codebuild/output/src371685941/src/support-ui/layouts/auth.vue").then(m => m.default || m)),
  dashboard: defineAsyncComponent(() => import("/codebuild/output/src371685941/src/support-ui/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/codebuild/output/src371685941/src/support-ui/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/codebuild/output/src371685941/src/support-ui/layouts/empty.vue").then(m => m.default || m))
}